// Import package dependencies
import React, { Fragment, useState, useEffect } from "react"

// Import routing requirements
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom"

//Import Context
import { AppContext } from "../shared/context/AppContext"

// Import components for the main App page
import Header from "../Header/Header"
import Footer from "../Footer/Footer"
import EscapeRooms from "../EscaperoomsPage/EscapeRooms"
import Zakelijk from "../Bedrijven/Zakelijk"
// import OnlineBedrijfsuitje from "../OnlineBedrijfsuitje/OnlineBedrijfsuitje"
// import Competition from "../Competition/Competition";
import FAQ from "../FAQ/FAQ"
import AlgemeneVoorwaarden from "../AlgemeneVW/AlgemeneVoorwaarden"
import Privacy from "../Privacy/Privacy"
import PayPage from "../PayPages/PayPage"
// import PayOECER from "../PayPages/PayOECER";
import PaymentComplete from "../PaymentComplete/PaymentComplete"
// import PaymentCompleteOEC from "../PaymentComplete/PaymentCompleteOEC";
import PageNotFound from "../PageNotFound/PageNotFound"
import ScrollToTop from "../shared/ScrollToTop"
import Klassement from "../Klassement/Klassement"
// import OECRanking from "../OECRanking/OECRanking";
import InfoPage from "../InfoPages/InfoPage.js"

// global App CSS files import
import "./Resets.css"
import "./App.css"

function App() {
  const [language, setLanguage] = useState("")
  const [dotcom, setDotcom] = useState(false)

  useEffect(() => {
    if (window.location.hostname === "escape-mystery.com") {
      setDotcom(true)
    } else {
      setDotcom(false)
    }
  }, [setDotcom])

  useEffect(() => {
    // A choice made with the flag toggle wins. It lives under its own key,
    // because older versions wrote "lang" = "NL" for every visitor, so that
    // value says nothing about what the visitor wants.
    let picked = null
    try {
      picked = window.localStorage.getItem("langPicked")
    } catch {}
    if (dotcom) {
      setLanguage("EN")
    } else if (picked === "EN" || picked === "NL") {
      setLanguage(picked)
    } else {
      // Otherwise follow the browser: Dutch (nl, nl-NL, nl-BE) gets Dutch,
      // everyone else (e.g. a Swiss visitor on de-CH or fr-CH) gets English.
      const langs = navigator.languages?.length
        ? navigator.languages
        : [navigator.language || ""]
      const dutch = String(langs[0] || "").toLowerCase().startsWith("nl")
      setLanguage(dutch ? "NL" : "EN")
    }
  }, [dotcom])

  return (
    <Router>
      <AppContext.Provider
        value={{
          language: language,
          setLanguage: setLanguage,
          dotcom: dotcom,
        }}
      >
        <Fragment>
          <ScrollToTop />
          <Header />
          <Switch>
            <Route
              path="/"
              exact
              render={() => <Redirect to="/escaperooms" />}
            />
            <Route
              path="/escaperooms"
              exact
              render={(props) => <EscapeRooms {...props} />}
            />
            <Route path="/faq" exact render={(props) => <FAQ {...props} />} />
            <Route
              path="/custom_escape_room"
              exact
              render={(props) => <Zakelijk {...props} />}
            />
            {/* Online bedrijfsuitje is hidden until the page is ready; old
                links land on the custom escape room page instead. */}
            <Redirect from="/online_bedrijfsuitje" to="/custom_escape_room" />

            {/* <Route
              path="/online_escape_competition"
              exact
              render={(props) => <Competition {...props} />}
            /> */}

            {/* <Route
              path="/online_escape_competition/rankings"
              exact
              render={(props) => <OECRanking {...props} />}
            /> */}

            <Route
              path="/voorwaarden"
              exact
              render={(props) => <AlgemeneVoorwaarden {...props} />}
            />
            <Route
              path="/privacy"
              exact
              render={(props) => <Privacy {...props} />}
            />

            {/* Escaperoom info pages */}

            <Route
              path="/escaperooms/info/:linktoPar"
              exact
              render={(props) => <InfoPage {...props} />}
            />

            <Route
              path="/escaperooms/pay/:linktoPar"
              exact
              render={(props) => <PayPage {...props} />}
            />

            <Route
              path="/rankings/:naam"
              exact
              render={(props) => <Klassement {...props} />}
            />
            {/* The old address, still in links clients already have */}
            <Redirect from="/klassementen/:naam" to="/rankings/:naam" />

            <Route
              path="/paymentcomplete/:orderId/:ERid"
              exact
              render={(props) => <PaymentComplete {...props} />}
            />
            {/* <Route
              path="/paymentcompleteOEC/:orderId"
              exact
              render={(props) => <PaymentCompleteOEC {...props} />}
            /> */}
            <Route path="/" render={(props) => <PageNotFound {...props} />} />
          </Switch>
          <Footer />
        </Fragment>
      </AppContext.Provider>
    </Router>
  )
}

export default App
